import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Key } from "@phosphor-icons/react";
import api from "@/lib/api";

export function HeaderCredits() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  const load = useCallback(() => {
    api.get("/activation/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const f = () => load();
    window.addEventListener("sb:activation-changed", f);
    window.addEventListener("focus", f);
    return () => { window.removeEventListener("sb:activation-changed", f); window.removeEventListener("focus", f); };
  }, [load]);

  if (!status || !status.required) return null;
  return (
    <button data-testid="header-credits" onClick={() => navigate("/dashboard")} title="Aktivierungen"
      className="flex items-center gap-1 h-10 px-2.5 rounded-2xl border-2 border-gray-800 bg-white active:scale-90 transition-transform shadow-[2px_2px_0_0_rgba(31,41,55,1)]">
      <Key size={18} weight="duotone" style={{ color: "var(--app-strong)" }} />
      <span data-testid="header-credits-count" className="font-heading font-bold text-sm text-gray-900">{status.credits || 0}</span>
    </button>
  );
}
